import {Result} from "antd";
import './error.scss'
import React from "react";

const ErrorPage = () => {
    return <Result className='error-page' status="error" title="Page not found!"/>;
};

export default ErrorPage;
